import React from "react";
import PropTypes from "prop-types";
import AccUserListTable from "../table/all-tables/accountingsoftwaretable/UserAccountingListmodaltable/AccUserListTable";
import { accSoftwarePage, buttonName } from "../../locales/en";
import CommonModal from "./CommonModal";

const UserAccountSoftwareListModal = ({ isOpen, toggle, roleId }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="modal-dialog modal-xl"
      title={accSoftwarePage?.modal.title}
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        }
      ]}
    >
      <div className="row">
        <div className="col-12">
          <AccUserListTable roleId={roleId} isOpen={isOpen} />
        </div>
      </div>
    </CommonModal>
  );
};

UserAccountSoftwareListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  roleId: PropTypes.any
};

export default UserAccountSoftwareListModal;
